<template>
  <div class="tile is-parent">
    <article class="tile is-child box">
      <p class="title">标签名称</p>
      <div class="block">
        <input class="input width-2" v-model="params.name"/>
      </div>
      <p class="title">生效时间</p>
      <div class="block">
        <el-date-picker
          v-model="params.startTime"
          type="datetime"
          placeholder="放行开始时间"
          align="right">
        </el-date-picker>
        <span class="r-top">~</span>
        <el-date-picker
          v-model="params.endTime"
          type="datetime"
          placeholder="放行结束时间"
          align="right">
        </el-date-picker>
      </div>

      <p class="title">上传图片</p>
      <div class="block">
        <span class="button is-primary" id="js_imageUploadBtn" style="line-height: 30px;">上传图片</span>
        <span class="upload-img-tips">建议尺寸：336＊128px(图片尺寸小于1M)</span>
      </div>
      <div class="block">
        <image-component :image="params.image" :width="300"></image-component>
      </div>
      <div class="block">
        <label class="label">应用夜市</label>
        <el-select
          v-model="nightMarketIds"
          multiple
          filterable
          @change="changeValueNightMarketId"
          @remove-tag="removeNightMarketId"
          placeholder="请选择">
          <el-option
            v-for="item in initNightmarketIds"
            :key="item.nightMarketId"
            :label="item.name"
            :value="parseInt(item.nightMarketId)">
          </el-option>
        </el-select>
      </div>
      <div class="block">
        <button class="button" @click="cancelEdit">取消</button>
        <button class="button is-info" @click="saveEdit" style="margin-left: 30px;">保存</button>
      </div>
    </article>
  </div>
</template>
<script type="text/babel">
import Uploader from 'COMMON/uploaderModule/uploader'
export default {
  data () {
    return {
      priceTagId: 0,
      params: {
        name: '',
        startTime: '',
        endTime: '',
        image: {
          image: '',
          width: 0,
          height: 0
        },
        nightMarkets: []
      },
      initNightmarketIds: [],
      nightMarketIds: [],
      nightMarketIdsTemp: []

    }
  },
  mounted: function () {
    this.$nextTick(function () {
      this.priceTagId = parseInt(this.$route.query.priceTagId)
      if (this.priceTagId > 0) {
        this.getPriceTag()
      }
      this.getNightMarkets()
      this.uploadMainBind()
    })
  },
  methods: {
    changeValueNightMarketId (value) {
      value.forEach((item) => {
        if (this.nightMarketIdsTemp.indexOf(item) === -1) {
          this.nightMarketIdsTemp.push(item)
          this.initNightmarketIds.forEach((nightMarkets) => {
            if (parseInt(nightMarkets.nightMarketId) === item) {
              this.params.nightMarkets.push({nightMarketId: item, name: nightMarkets.name})
            }
          })
        }
      })
    },
    removeNightMarketId (removeItem) {
      this.params.nightMarkets.forEach((nightMarkets, index) => {
        if (parseInt(nightMarkets.nightMarketId) === removeItem.value) {
          this.params.nightMarkets.splice(index, 1)
        }
      })
    },
    uploadMainBind () {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: '#js_imageUploadBtn',
            multiple: false
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image',
          fileSizeLimit: 1 * 1024 * 1024,
          fileSingleSizeLimit: 1 * 1024 * 1024
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            this.params.image.image = response.data.images.info.path
            this.params.image.width = response.data.images.info.width
            this.params.image.height = response.data.images.info.height
          },
          onError (response, file, uploaderObj) {
          }
        }
      }
      new Uploader(params)
    },
    // 获取专题分类详情
    getPriceTag () {
      HttpRequest.get('/admin.php?method=activity11.getPriceTag', {priceTagId: this.priceTagId}, true).then((response) => {
        this.params = response.data
        this.params.nightMarkets.forEach((item) => {
          this.nightMarketIds.push(parseInt(item.nightMarketId))
        })
      }, (response) => {
      })
    },
    getNightMarkets () {
      HttpRequest.get('/admin.php?method=activity11.getNightMarkets', {}, true).then((response) => {
        this.initNightmarketIds = response.data
      }, (response) => {
      })
    },
    // 保存编辑
    saveEdit () {
      let params = Object.assign({}, this.params)
      params.priceTagId = this.priceTagId
      if (!params.name) {
        this.$message('请输入标签名称')
        return
      }
      if (!params.image.image) {
        this.$message('请上传图片')
        return
      }
      let idsArr = []
      params.nightMarkets.forEach(function (item, index) {
        idsArr.push(item.nightMarketId)
      })
      params.nightMarketIds = idsArr
      HttpRequest.post('/admin.php?method=activity11.doSavePriceTag', params, true).then((response) => {
        this.$message('保存成功', 1000)
        setTimeout(() => {
          this.$router.push({name: 'priceTag'})
        })
      }, (response) => {

      })
    },
    cancelEdit () {
      this.$router.push({name: 'priceTag'})
    }
  }
}
</script>
<style lang="less" scoped>
  .upload-img-tips{
    position: relative;
    top: 10px;
    color: #ff0000;
  }
  .el-select{
    width:100%;
    .el-select__tags{
      .el-tag.el-tag--primary {
        background-color: #41b883;
        border-color: #fff;
        color: #fff;
      }
    }
  }
  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
    background: #f3f3f3;
    color: #35495e;
    font-weight: 700;
  }
  .el-select-dropdown.is-multiple .el-select-dropdown__item.hover {
    background: #41b883;
    outline: none;
    color: #fff;
  }
  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover, .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background: #ff6a6a;
    color: #fff;
  }
</style>
